import { ChangeEvent, useState } from 'react';
import { styled } from '@stitches/configed';
import Layout from './Layout';
import Button from '../Common/Button';
import Form, { Field } from '../Common/Form';
import Input from '../Common/Input';
import { Result } from '../Common/Result';
import CheckCircleIcon from '../Common/Icons/CheckCirleIcon';
import { useNavigate } from 'react-router-dom';

const Title = styled('h4', {
  uTextSize: 'lg',
  fontWeight: 400,
  textAlign: 'center',
  marginBottom: 24,
});

const ShowPass = styled('div', {
  color: '$link',
  cursor: 'pointer',
});
const Submit = styled(Button, {
  height: 52,
});
const RowCheck = styled('div', {
  display: 'flex',
  alignItems: 'center',
  uGap: 4,
  svg: {
    color: '#D9DCE1',
  },
  variants: {
    passed: {
      true: {
        svg: {
          color: '#17AFA7',
        },
      },
    },
  },
});
export default function CreateNewPass() {
  const [showResult, setShowResult] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [isSixChar, setIsSixChar] = useState(false);
  const [isHasUppercase, setIsHasUppercase] = useState(false);
  const [isHasNumber, setIsHasNumber] = useState(false);
  const [isHasSpecialChar, setIsHasSpecicalChar] = useState(false);
  const navigate = useNavigate();
  const name = 'Kiệt';

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    const password = e.target.value;
    if (password.length >= 6) {
      setIsSixChar(true);
    } else {
      setIsSixChar(false);
    }
    if (/[A-Z]/.test(password)) {
      setIsHasUppercase(true);
    } else {
      setIsHasUppercase(false);
    }
    /[0-9]/.test(password) ? setIsHasNumber(true) : setIsHasNumber(false);
    /[!@#$%^&*(),.?":{}|<>]/.test(password)
      ? setIsHasSpecicalChar(true)
      : setIsHasSpecicalChar(false);
  };
  const onFinish = (value: any) => {
    setShowResult(true);
  };
  if (showResult) {
    return (
      <Layout>
        <Result
          type="success"
          title="Mật khẩu cập nhật thành công."
          message="Từ bây giờ bạn sẽ sử dụng email và mật khẩu mới để đăng nhập hệ thống."
        >
          <Button btnType="primary" onClick={() => navigate('/login')}>
            Đăng nhập tài khoản
          </Button>
        </Result>
      </Layout>
    );
  }
  return (
    <Layout>
      <Form layout="vertical" onFinish={onFinish} validateTrigger="onSubmit">
        <Title>
          Chào <b>{name}</b>,<br />
          Vui lòng đổi mật khẩu mới để tiếp tục sử dụng
        </Title>
        <Field
          label="Mật khẩu mới"
          name="password"
          rules={[
            { required: true, message: 'Vui lòng nhập mật khẩu!' },
            {
              min: 6,
              message: 'Vui lòng nhập ít nhất 6 ký tự!',
            },
          ]}
        >
          <Input
            placeholder="Nhập mật khẩu mới"
            type={showPass ? 'text' : 'password'}
            onChange={handlePasswordChange}
          />
        </Field>
        <Field
          label="Nhập lại mật khẩu"
          name="re-password"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Vui lòng nhập mật khẩu!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('Hai mật khẩu đã nhâp không khớp!'),
                );
              },
            }),
          ]}
        >
          <Input
            placeholder="Nhập mật lại khẩu mới"
            type={showPass ? 'text' : 'password'}
          />
        </Field>
        <Field>
          <ShowPass onClick={() => setShowPass(!showPass)}>
            {showPass ? 'Ẩn' : 'Hiện'} mật khẩu
          </ShowPass>
        </Field>
        <Field>
          Mật khẩu có độ bảo mật cao, nên có:
          <RowCheck passed={isSixChar}>
            <CheckCircleIcon />
            <span>Ít nhất 6 kí tự</span>
          </RowCheck>
          <RowCheck passed={isHasUppercase}>
            <CheckCircleIcon />
            <span>Có ký tự viết hoa (từ A - Z)</span>
          </RowCheck>
          <RowCheck passed={isHasNumber}>
            <CheckCircleIcon />
            <span>Có ký tự số (từ 0 - 9)</span>
          </RowCheck>
          <RowCheck passed={isHasSpecialChar}>
            <CheckCircleIcon />
            <span>Có ký tự đặt biệt (? * @...)</span>
          </RowCheck>
        </Field>
        <Field>
          <Submit btnType="primary" type="submit">
            Cập nhật
          </Submit>
        </Field>
      </Form>
    </Layout>
  );
}
